import React from "react";
import "./spinnerLoader.scss";

const SpinnerLoader = () => {
  return <div id="loading"></div>;
};

export default SpinnerLoader;
